<template>
    <div class=" relative z-10 inline-flex shadow-sm rounded-md">
        <button
            @click.stop="displayMenu"
            type="button"
            class="
                select-sort 
                rounded-md p-1 
                flex items-center
                bg-indigo-300 text-gray-900 hover:bg-indigo-200 
                focus:outline-none transition ease-in-out duration-150 
                text-base font-normal leading-5
            "
        >
            <div 
                class="
                    relative inline-flex items-center
                    px-4 py-2 2xl:px-5 2xl:py-3 
                    rounded-md bg-indigo-200
                    w-max
                "
            >
                <icon 
                    v-if="['ABC', 'JAN'].includes(sort)" 
                    name="arrow-down" 
                    class="sm:-ml-1 sm:mr-2 h-3.5 w-3.5 text-pink-600" 
                />
                <icon 
                    v-if="['ZYX', 'DEC'].includes(sort)" 
                    name="arrow-up" 
                    class="sm:-ml-1 sm:mr-2 h-3.5 w-3.5 text-pink-600"
                />
                
                <span v-if="sort == 'ABC'">ABC</span>
                <span v-if="sort == 'ZYX'">ZYX</span>
                <span v-if="sort == 'JAN'">01 JAN</span>
                <span v-if="sort == 'DEC'">31 DEC</span>
            </div>
            <div
                class="flex px-4 text-base items-center w-max"
                :class="{'hidden lg:flex' : responsive}"
            >
                <div class="mr-2" v-if="sort == 'ABC'">Tri alphabétique</div>
                <div class="mr-2" v-if="sort == 'ZYX'">Tri anti-alphabétique</div>
                <div class="mr-2" v-if="sort == 'JAN'">Tri chronologique</div>
                <div class="mr-2" v-if="sort == 'DEC'">Tri anti-chronologique</div>
                <icon name="chevron-down" class="text-indigo-600" />
            </div>
        </button>

        <!-- BEGIN Select field appears when click on input -->

    <div
      class="absolute overflow-scroll rounded-md bg-white shadow-lg shadow-gray-600 text-sm ml-auto top-15 p-5"
      :class="{
        'w-auto lg:w-full -left-full lg:left-auto' : responsive,
        'w-full' : !responsive
      }"
      :hidden="!isMenuDisplayed"
      v-clickOutside="forceHide"
    >
      <div class="text-left">
        <div class="text-indigo-600 text-sm pb-2 ">
          Trier par nom de famille
        </div>
        <div class="pb-1 last:pb-0 text-gray-600 cursor-pointer hover:font-semibold flex items-center">
          <icon
            class="h-2.5 mr-2 text-pink-600"
            name="arrow-down"
          /><span
            @click="changeSort('ABC')"
            :class="{'font-semibold': sort == 'ABC'}"
          >ABC - Alphabétique</span>
        </div>
        <div class="pb-3 last:pb-0 text-gray-600 cursor-pointer hover:font-semibold flex items-center">
          <icon
            class="h-2.5 mr-2 text-pink-600"
            name="arrow-up"
          /><span
            @click="changeSort('ZYX')"
            :class="{'font-semibold': sort == 'ZYX'}"
          >ZYX - Anti-alphabétique</span>
        </div>

        <div class="text-indigo-600 text-sm pb-2">
          Trier par date de création
        </div>
        <div class="pb-1 last:pb-0 text-gray-600 cursor-pointer hover:font-semibold flex items-center">
          <icon
            class="h-2.5 mr-2 text-pink-600"
            name="arrow-down"
          /><span
            @click="changeSort('JAN')"
            :class="{'font-semibold': sort == 'JAN'}"
          >01 JAN - Chronologique</span>
        </div>
        <div class="pb-3 last:pb-0 text-gray-600 cursor-pointer hover:font-semibold flex items-center">
          <icon
            class="h-2.5 mr-2 text-pink-600"
            name="arrow-up"
          /><span
            @click="changeSort('DEC')"
            :class="{'font-semibold': sort == 'DEC'}"
          >31 DEC - Anti-chronologique</span>
        </div>
        <!-- Manage new datas when click on add link -->
        <!-- END Manage new datas when click on add link -->
      </div>
    </div>
    <!-- END Select field appears when click on input -->
  </div>
</template>

<script>

import Icon from './Icon';

export default {
  props: {
    sort: String,
    responsive: {
      type: Boolean,
      default: false,
    }
  },

  components:{
    Icon,
  },

  data(){
    return{
      isMenuDisplayed: false,
    };
  },
    
  methods:{
    displayMenu(e){
      if(e.x < (2*window.outerWidth/3)){ //to move the bloc options on right or left according to the position on the screen
        document.querySelectorAll('.select-sort')[0].classList.remove('right-0');
      }

      this.isMenuDisplayed = !this.isMenuDisplayed;
    },

    forceHide(e){
      if(e.target.classList.contains('button-sort')){
        this.displayMenu(e);
      }else{
        if(this.isMenuDisplayed){
          this.isMenuDisplayed = false;
        }
      }
    },

    changeSort(type){
      this.$emit('sorted', type);
      this.isMenuDisplayed=false;
    },
  },

  directives: {
    clickOutside:{
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
                    
          if (compName) { warn += `Found in component '${compName}'`; }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>
